import { Fab } from '@mui/material'
import React, { useState } from 'react'
import '../../assets/styles/custom.css'
import Icon from '../../assets/images/logo.png'
import Icon1 from '../../assets/images/education logo.png'
import Body from '../chatflow/Body'

const ChatBotFrame = () => {

    const [showIcon, setShowIcon] = React.useState(true);
    const [showChat, setShowChat] = React.useState(false);

    const [time] = useState(new Date());

  return (
    <div>
        {showIcon &&
        <div className='icon'>
        <Fab color="primary" aria-label="add" onClick={() => {
            setShowChat(true);
            setShowIcon(false);
        }}>  
          <img src={Icon1} alt="Akaay Logo" className='icon-img' />    
        </Fab>

        </div>}

        {showChat &&(
            <div className='background-frame'>
                <div className="head">
            <img src={Icon}alt="Akaay Logo" className="logo" />
            <div>
              <div className="head-text">AKAAY UNIVERSITY</div>
              <div className="head-qoute">We are online to assist you </div>
            </div>
            
            <button className="close-icon" onClick={() => {
                setShowChat(false);
                setShowIcon(true);}}>
              &#10006;
            </button>
          </div>
          <div className="time">Today {time.toLocaleTimeString()}</div>
          <div className="body">
            
            <Body />
            
          </div>
          <div className="footer">
            Powered by <b>AKAAY AI</b>
          </div>
          
            </div>
        )}
    </div>
  )
}
export default ChatBotFrame